export const Arrows = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16.875 16.9863V8.225C16.875 8.0317 16.7183 7.875 16.525 7.875H13.2248C13.0316 7.875 12.8749 8.03158 12.8748 8.2248L12.8697 16.9865C12.8696 17.1797 12.7129 17.3363 12.5197 17.3363H10.1268C9.82926 17.3363 9.66741 17.6839 9.85891 17.9116L14.6072 23.5566C14.747 23.7228 15.003 23.7228 15.1428 23.5566L19.8911 17.9116C20.0826 17.6839 19.9207 17.3363 19.6232 17.3363H17.225C17.0317 17.3363 16.875 17.1796 16.875 16.9863Z"
      fill="url(#paint0_linear_7360_41416)"
    />
    <path
      d="M11.25 6.88873V15.65C11.25 15.8433 11.0933 16 10.9 16H7.5998C7.40658 16 7.24991 15.8434 7.2498 15.6502L7.24467 6.88853C7.24455 6.69531 7.08789 6.53873 6.89467 6.53873H4.50175C4.20426 6.53873 4.04241 6.1911 4.23391 5.96344L8.98215 0.318432C9.12201 0.152161 9.37799 0.152161 9.51785 0.318432L14.2661 5.96344C14.4576 6.1911 14.2957 6.53873 13.9982 6.53873H11.6C11.4067 6.53873 11.25 6.69544 11.25 6.88873Z"
      fill="url(#paint1_linear_7360_41416)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7360_41416"
        x1="14.875"
        y1="7.875"
        x2="14.875"
        y2="23.875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ACD41E" />
        <stop offset="1" stopColor="#ECF181" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7360_41416"
        x1="9.25"
        y1="0"
        x2="9.25"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E47E05" />
        <stop offset="1" stopColor="#FFDE4A" />
      </linearGradient>
    </defs>
  </svg>
);
